
<script setup>

  const props = defineProps( {
    
    current: { type: Number, default: 1 },
    
    total: { type: Number, default: 1 }
  
  } );

</script>

<template>

  <div class="flex gap-2">

    <div v-for="( empty, index ) in Array( total )"
    
      :class="[
        
        'flex items-center justify-center w-8 h-8 text-xs font-bold rounded-full border-2 border-neutral-600',
        
        index === current - 1 ? 'text-white bg-neutral-600' : 'text-neutral-600'
        
      ]">
      
      {{ index + 1 }}
    
    </div>

  </div>

</template>
